/**
 * Het gedeelde rechtenblok (05-10-2026, Jordy): hetzelfde blok in Settings →
 * Users (aanmaken en bewerken) en in Chatters (aanmaken en Edit chatter). Toont
 * alleen wat voor de gekozen rol betekenis heeft. Alleen een owner kan iets
 * omzetten (de server weigert anderen met 403); voor anderen is het blok
 * alleen-lezen. 07-10-2026 (Jordy): een admin mag de rechten met `ookAdmin`
 * (de schuif "Mass Messages page"). De lijst zelf staat in lib/rechtenBlok.ts.
 */
import { rechtenVoorRol, staatAan, zetRecht, type Recht } from '../lib/rechtenBlok'

const KOPPEN: Record<Recht['groep'], string> = {
  paginas: 'Pages',
  massa: 'Mass Messages',
  rechten: 'Permissions',
  filters: 'Mass DM filters (what this chatter may set)',
}

export function RechtenBlok({
  rol, pages, onChange, magWijzigen, isLead = false, adminMag = false,
}: {
  rol: string
  pages: string[]
  onChange: (pages: string[]) => void
  /** Alleen een owner. */
  magWijzigen: boolean
  isLead?: boolean
  /** 07-10-2026: wie dit opent is admin; die zet alleen de rechten met `ookAdmin`. */
  adminMag?: boolean
}) {
  const r = String(rol || '').toLowerCase()
  if (r === 'owner' || r === 'admin') {
    return (
      <div className="field" data-testid="rechtenblok" data-rol={r}>
        <label>Permissions</label>
        <div className="hint">Owners and admins have every permission.</div>
      </div>
    )
  }
  const lijst = rechtenVoorRol(r, isLead)
  const groepen = (['paginas', 'massa', 'rechten', 'filters'] as const)
    .map((g) => ({ g, items: lijst.filter((x) => x.groep === g) }))
    .filter((x) => x.items.length)
  return (
    <div className="field" data-testid="rechtenblok" data-rol={r}>
      {!lijst.length ? <div className="hint">No separate permissions for this role.</div> : null}
      {groepen.map(({ g, items }) => (
        <div key={g} style={{ marginBottom: 10 }}>
          <label>{KOPPEN[g]}</label>
          <div className="cols" style={{ gridTemplateColumns: '1fr 1fr', gap: 4, marginTop: 4 }}>
            {items.map((recht) => {
              const aan = staatAan(pages, recht)
              const mag = magWijzigen || (adminMag && Boolean(recht.ookAdmin))
              return (
                <div key={recht.sleutel}>
                  <label className="chkrow" style={{ padding: 0, cursor: mag ? 'pointer' : 'default', opacity: mag ? 1 : 0.6 }}>
                    <span className={aan ? 'chk on' : 'chk'} role="switch" aria-checked={aan} aria-label={recht.label}
                          aria-disabled={!mag} data-testid={`recht-${recht.sleutel}`}
                          onClick={() => { if (mag) onChange(zetRecht(pages, recht, !aan)) }}>
                      {aan ? '✓' : ''}
                    </span>
                    {recht.label}
                  </label>
                  {recht.hint ? <div className="hint">{recht.hint}</div> : null}
                </div>
              )
            })}
          </div>
        </div>
      ))}
      {!magWijzigen && lijst.length ? (
        <div className="hint">
          {adminMag && lijst.some((x) => x.ookAdmin)
            ? 'As an admin you can change only the Mass Messages page switch. Only an owner can change the other permissions.'
            : 'Only an owner can change permissions.'}
        </div>
      ) : null}
    </div>
  )
}
